import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GenericsService } from './generics.service';
import { LoginService } from './login.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Bearer OTA2ZmFlM2Y3MWZiZmM1ZmRhMWEzYThmODdiNzU4ODE='
  })
};

@Injectable({
  providedIn: 'root'
})
export class CadastroUsuarioService {

  constructor(private generics: GenericsService,
              private loginServ: LoginService,
              private http: HttpClient) { }

  public cadastrarUsuario(form:any) {
      if (form.id == null) {
        delete form.id;
        return this.generics.post('usuario', JSON.stringify(form));
      }
      else {
        let id = form.id;
        delete form.id;
        return this.generics.put('usuario/' + id, JSON.stringify(form));
      }
    }

}
